"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Theme = _interopRequireDefault(require("../Theme"));
var _Popover = _interopRequireDefault(require("../Popover"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _Link = _interopRequireDefault(require("../Link"));
var _constant = require("../Popover/constant");
var _baggageHeader = _interopRequireDefault(require("./baggageHeader.proptypes"));
var _constant2 = require("./constant");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var BaggageHeaderWrapper = _styledComponents.default.div.withConfig({
  displayName: "BaggageHeader__BaggageHeaderWrapper",
  componentId: "sc-16pv0q7-0"
})(["display:flex;flex-flow:row wrap;background-color:", ";padding:", ";"], function (_ref) {
  var theme = _ref.theme,
    baggageTypeColor = _ref.baggageTypeColor;
  return theme.backgroundColor[baggageTypeColor];
}, function (_ref2) {
  var theme = _ref2.theme;
  return "".concat(theme.space.micro, " ").concat(theme.space.small);
});
var BaggageHeading = _styledComponents.default.div.withConfig({
  displayName: "BaggageHeader__BaggageHeading",
  componentId: "sc-16pv0q7-1"
})(["font-family:", ";font-size:", ";font-weight:", ";line-height:", ";color:", ";margin-right:", ";"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.fontFamily.default;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.fontSize.small;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.fontWeight.medium;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.lineHeight.semiLarge;
}, function (_ref7) {
  var theme = _ref7.theme,
    baggageHeadingColor = _ref7.baggageHeadingColor;
  return theme.colors[baggageHeadingColor];
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.space.micro;
});
var ToolTipContainer = _styledComponents.default.div.withConfig({
  displayName: "BaggageHeader__ToolTipContainer",
  componentId: "sc-16pv0q7-2"
})(["display:flex;justify-content:center;align-items:center;"]);
var ToolTipContent = _styledComponents.default.div.withConfig({
  displayName: "BaggageHeader__ToolTipContent",
  componentId: "sc-16pv0q7-3"
})(["display:flex;flex-flow:column wrap;"]);
var Title = _styledComponents.default.div.withConfig({
  displayName: "BaggageHeader__Title",
  componentId: "sc-16pv0q7-4"
})(["font-family:", ";font-size:", ";font-weight:", ";line-height:", ";color:", ";margin-bottom:", ";"], function (_ref9) {
  var theme = _ref9.theme;
  return theme.fontFamily.default;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.fontSize.normal;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.fontWeight.medium;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.lineHeight.XLarge;
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.colors.neutral;
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.space.micro;
});
var Content = _styledComponents.default.div.withConfig({
  displayName: "BaggageHeader__Content",
  componentId: "sc-16pv0q7-5"
})(["font-family:", ";font-size:", ";font-weight:", ";line-height:", ";color:", ";margin-top:", ";"], function (_ref15) {
  var theme = _ref15.theme;
  return theme.fontFamily.default;
}, function (_ref16) {
  var theme = _ref16.theme;
  return theme.fontSize.small;
}, function (_ref17) {
  var theme = _ref17.theme;
  return theme.fontWeight.normal;
}, function (_ref18) {
  var theme = _ref18.theme;
  return theme.lineHeight.semiLarge;
}, function (_ref19) {
  var theme = _ref19.theme;
  return theme.colors.greyDarker;
}, function (_ref20) {
  var theme = _ref20.theme;
  return theme.space.micro;
});
var ToolTipIcon = _styledComponents.default.div.withConfig({
  displayName: "BaggageHeader__ToolTipIcon",
  componentId: "sc-16pv0q7-6"
})(["display:flex;flex-direction:row;align-items:center;"]);
var MainList = _styledComponents.default.ul.withConfig({
  displayName: "BaggageHeader__MainList",
  componentId: "sc-16pv0q7-7"
})(["margin:", ";padding:", ";"], function (_ref21) {
  var theme = _ref21.theme;
  return "".concat(theme.space.none, " ").concat(theme.space.none, " ").concat(theme.space.none, " ").concat(theme.space.small);
}, function (_ref22) {
  var theme = _ref22.theme;
  return theme.space.none;
});
var ListItem = _styledComponents.default.li.withConfig({
  displayName: "BaggageHeader__ListItem",
  componentId: "sc-16pv0q7-8"
})([""]);
var IconGrid = _styledComponents.default.div.withConfig({
  displayName: "BaggageHeader__IconGrid",
  componentId: "sc-16pv0q7-9"
})(["display:grid;grid-template-columns:repeat(2,calc(100% / 2));margin-bottom:", ";"], function (_ref23) {
  var theme = _ref23.theme;
  return theme.space.tiny;
});
var IconItem = _styledComponents.default.div.withConfig({
  displayName: "BaggageHeader__IconItem",
  componentId: "sc-16pv0q7-10"
})(["display:flex;"]);
var IconContainer = _styledComponents.default.div.withConfig({
  displayName: "BaggageHeader__IconContainer",
  componentId: "sc-16pv0q7-11"
})(["display:flex;justify-content:center;align-items:center;margin-right:", ";"], function (_ref24) {
  var theme = _ref24.theme;
  return theme.space.tiny;
});
var getList = function getList(contentList) {
  return /*#__PURE__*/_react.default.createElement(MainList, {
    key: _constant2.TOOLTIP_CONTENT_TYPE.list
  }, contentList.map(function (listItem) {
    return /*#__PURE__*/_react.default.createElement(ListItem, {
      key: listItem
    }, listItem);
  }));
};
var getLink = function getLink(ctaText, ctaLink) {
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
    key: _constant2.TOOLTIP_CONTENT_TYPE.link
  }, /*#__PURE__*/_react.default.createElement(_Link.default, {
    color: _constant2.LINK_TYPE.info.color,
    hoverUnderlined: true,
    href: ctaLink,
    size: _constant2.LINK_TYPE.info.size
  }, ctaText || _constant2.TRANSLATION.readMore));
};
var getIcons = function getIcons(iconArr, translation) {
  return /*#__PURE__*/_react.default.createElement(IconGrid, {
    key: _constant2.TOOLTIP_CONTENT_TYPE.icons
  }, iconArr.map(function (_ref25) {
    var icon = _ref25.icon,
      translationKey = _ref25.translationKey;
    return /*#__PURE__*/_react.default.createElement(IconItem, {
      key: "".concat(icon, "_").concat(translationKey)
    }, /*#__PURE__*/_react.default.createElement(IconContainer, null, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      color: _constant2.ICON_TYPE.sports.color,
      fontsize: _constant2.ICON_TYPE.sports.size,
      icon: icon
    })), /*#__PURE__*/_react.default.createElement(Content, null, translation[translationKey] || translationKey));
  }));
};
var getToolTipByType = function getToolTipByType(toolTipContent, translation) {
  return toolTipContent.map(function (contentType) {
    var type = contentType.type;
    if (type === _constant2.TOOLTIP_CONTENT_TYPE.list) {
      var _contentType$content = contentType.content,
        content = _contentType$content === void 0 ? [] : _contentType$content;
      return getList(content);
    }
    if (type === _constant2.TOOLTIP_CONTENT_TYPE.text) {
      var _contentType$content2 = contentType.content,
        _content = _contentType$content2 === void 0 ? [] : _contentType$content2;
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
        key: _constant2.TOOLTIP_CONTENT_TYPE.text
      }, _content[0]);
    }
    if (type === _constant2.TOOLTIP_CONTENT_TYPE.link) {
      var _contentType$ctaText = contentType.ctaText,
        ctaText = _contentType$ctaText === void 0 ? '' : _contentType$ctaText,
        _contentType$ctaLink = contentType.ctaLink,
        ctaLink = _contentType$ctaLink === void 0 ? '' : _contentType$ctaLink;
      return getLink(ctaText, ctaLink);
    }
    if (type === _constant2.TOOLTIP_CONTENT_TYPE.icons) {
      var _contentType$content3 = contentType.content,
        _content2 = _contentType$content3 === void 0 ? [] : _contentType$content3;
      return getIcons(_content2, translation);
    }
    return null;
  });
};
var BaggageHeader = function BaggageHeader(props) {
  var theme = props.theme,
    accessible = props.accessible,
    baggageType = props.baggageType,
    baggageHeadingColor = props.baggageHeadingColor,
    baggageTypeColor = props.baggageTypeColor,
    translation = props.translation,
    showToolTip = props.showToolTip,
    isMobile = props.isMobile,
    toolTipColor = props.toolTipColor,
    customToolTipContent = props.customToolTipContent,
    toolTipContent = props.toolTipContent,
    toolTipTitle = props.toolTipTitle;
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  var tabIndex = !accessible ? '-1' : '0';
  var language = _objectSpread(_objectSpread({}, _constant2.TRANSLATION), translation);
  var getToolTipContent = function getToolTipContent() {
    if (customToolTipContent) {
      return /*#__PURE__*/_react.default.createElement(ToolTipContent, null, customToolTipContent);
    }
    return /*#__PURE__*/_react.default.createElement(ToolTipContent, null, /*#__PURE__*/_react.default.createElement(Title, null, toolTipTitle || language.toolTipTitle), toolTipContent[0] ? /*#__PURE__*/_react.default.createElement(Content, null, getToolTipByType(toolTipContent, translation)) : /*#__PURE__*/_react.default.createElement(Content, null, language.toolTipLabel));
  };
  var getMain = function getMain() {
    return /*#__PURE__*/_react.default.createElement(BaggageHeaderWrapper, {
      tabIndex: tabIndex,
      baggageTypeColor: baggageTypeColor || _constant2.BAGGAGETYPE_COLOR[baggageType].baggageTypeColor
    }, /*#__PURE__*/_react.default.createElement(BaggageHeading, {
      baggageHeadingColor: baggageHeadingColor || _constant2.BAGGAGETYPE_COLOR[baggageType].baggageHeadingColor
    }, language[baggageType]), /*#__PURE__*/_react.default.createElement(ToolTipContainer, null, showToolTip && /*#__PURE__*/_react.default.createElement(_Popover.default, {
      theme: theme,
      accessible: accessible,
      asToolTip: true,
      content: getToolTipContent(),
      position: isMobile ? _constant.CONTENT_POSITION.TOP : _constant.CONTENT_POSITION.BOTTOM,
      trigger: isMobile ? _constant.TRIGGERS.click : _constant.TRIGGERS.hover,
      width: _constant2.TOOLTIP_PROPS.WIDTH,
      zIndex: _constant2.TOOLTIP_PROPS.Z_INDEX
    }, /*#__PURE__*/_react.default.createElement(ToolTipIcon, null, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      theme: theme,
      accessible: accessible,
      color: toolTipColor || _constant2.BAGGAGETYPE_COLOR[baggageType].toolTipColor,
      fontsize: _constant2.ICON_TYPE.info.size,
      icon: _constant2.ICON_TYPE.info.type
    })))));
  };
  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};
BaggageHeader.propTypes = _baggageHeader.default.PropTypes;
BaggageHeader.defaultProps = _baggageHeader.default.DefaultProps;
var _default = BaggageHeader;
exports.default = _default;